export default {
  tableActionText: 'Pulse "Añadir" para agregar un nuevo elemento',
  title: 'Datos de inmovilizado y Gastos Financieros a Oficinas',
  info: 'En esta pantalla usted puede agregar datos de inmovilizado y gastos financieros a oficinas para cada una de las líneas.',
  question: 'Si desea cumplimentar datos de inmovilizados o gastos financieros a oficinas marque el check',
  check: 'Deseo cumplimentar datos de inmovilizado o gastos financieros a oficinas',
  headers: {
    officeId: 'Id. Oficina',
    fileNumber: 'Ficha de inmovilizado',
    appraisalAmount: 'Importe de la tasación',
    invoiceAmount: 'Importe de la factura'
  },
  inmobilizedData: {
    title: 'Datos de inmovilizado'
  },
  officeFinancialExpenses: {
    title: 'Gastos Financieros a Oficinas'
  }
}
